import Inventory from '@/orderControlModule/main.vue';
export default Inventory;
